// extracted by mini-css-extract-plugin
module.exports = {"Onu":"Onu_Onu__1kBX7","link":"Onu_link__16esU","active":"Onu_active__3p3iy"};